export class SaveAdminRequest {
  ContactId: string;
  FirstName: string;
  LastName: string;
  EmailAddress: string;
  IsActive: boolean;

  constructor(contactId: string
    , firstName: string
    , lastName: string
    , emailAddress: string
    , isActive: boolean
  ) {
    this.ContactId = contactId;
    this.FirstName = firstName;
    this.LastName = lastName;
    this.EmailAddress = emailAddress;
    this.IsActive = isActive;
  }
}
